// Copyright (c) Brock Allen & Dominick Baier. All rights reserved.
// Licensed under the Apache License, Version 2.0. See LICENSE in the project root for license information.

let nopLogger = {
    debug() {},
    info() {},
    warn() {},
    error() {},
};

let logger: any;
let level: number;

export class Logger {
    static NONE = 0;
    static ERROR = 1;
    static WARN = 2;
    static INFO = 3;
    static DEBUG = 4;

    static reset() {
        level = this.INFO;
        logger = nopLogger;
    }

    static get level() {
        return level;
    }

    static set level(value) {
        if (this.NONE <= value && value <= this.DEBUG) {
            level = value;
        } else {
            throw new Error('Invalid log level');
        }
    }

    static get logger() {
        return logger;
    }

    static set logger(value) {
        if (!value.debug && value.info) {
            // just to stay backwards compat. can remove in 2.0
            value.debug = value.info;
        }

        if (value.debug && value.info && value.warn && value.error) {
            logger = value;
        } else {
            throw new Error('Invalid logger');
        }
    }

    static debug(...args: any) {
        if (level >= this.DEBUG) {
            logger.debug.apply(logger, Array.from(args));
        }
    }

    static info(...args: any) {
        if (level >= this.INFO) {
            logger.info.apply(logger, Array.from(args));
        }
    }

    static warn(...args: any) {
        if (level >= this.WARN) {
            logger.warn.apply(logger, Array.from(args));
        }
    }

    static error(...args: any) {
        if (level >= this.ERROR) {
            logger.error.apply(logger, Array.from(args));
        }
    }
}

Logger.reset();
